package ui.pages

import js.lazy.Lazy
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.router.Outlet
import ui.styles.Styles

@Lazy
val Content = FC<Props> {

    ReactHTML.main{
        className = Styles.ContentBox.contentBox

        Outlet()
    }
}